module.exports = __webpack_public_path__ + "static/img/che07.51f8176.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/che07.png
// module id = +B0i
// module chunks = 1